import {cn} from '@/lib/utils'

type StatVariant = 'default' | 'success' | 'danger' | 'primary' | 'muted'

interface StatValueProps {
    value: string | number
    variant?: StatVariant
    size?: 'md' | 'lg'
    className?: string
    'data-testid'?: string
}

/* eslint-disable i18next/no-literal-string -- CSS class constants */
const variantClasses: Record<StatVariant, string> = {
    default: '',
    success: 'text-status-success dark:text-status-success-muted',
    danger: 'text-destructive',
    primary: 'text-primary',
    muted: 'text-muted-foreground',
}
/* eslint-enable i18next/no-literal-string */

export function StatValue({value, variant = 'default', size = 'md', className, 'data-testid': testId}: StatValueProps) {
    return (
        <p
            className={cn(
                'font-bold',
                size === 'lg' ? 'text-3xl' : 'text-2xl',
                variantClasses[variant],
                className,
            )}
            data-testid={testId}
        >
            {value}
        </p>
    )
}
